import React from "react";
import "./../styles/global.scss";
import Navbar from "./../components/Navbar";
import IndexPage from "./index";
import FaqPage from "./faq";
import DisclaimerPage from "./disclaimer";
import CrowdSourcePage from "./crowdsource";
import { Switch, Route, Router } from "./../util/router.js";
import Footer from "./../components/Footer";
import "./../util/analytics.js";
import { ProvideAuth } from "./../util/auth.js";

function App(props) {
  return (
    <ProvideAuth>
      <Router>
        <>
          <Navbar
            color="primary"
            spaced={true}
            logo="./logo_2.svg"
          ></Navbar>

          <Switch>
            <Route exact path="/" component={IndexPage} />

            <Route exact path="/faq" component={FaqPage} />
            <Route exact path="/disclaimer" component={DisclaimerPage} />

            <Route exact path="/crowd-source" component={CrowdSourcePage} />

            <Route
              component={({ location }) => {
                return (
                  <div
                    style={{
                      padding: "50px",
                      width: "100%",
                      textAlign: "center"
                    }}
                  >
                    The page <code>{location.pathname}</code> could not be
                    found.
                  </div>
                );
              }}
            />
          </Switch>

          <Footer
            color="white"
            size="medium"
            backgroundImage=""
            backgroundImageOpacity={1}
            copyright="© 2020 Covid Crowdsource"
            logo="./logo.svg"
          ></Footer>
        </>
      </Router>
    </ProvideAuth>
  );
}

export default App;
